(function () {
  var countdownEls = document.querySelectorAll(".s12-cro-countdown");
  if (!countdownEls.length) return;

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function computeEndDate(endHour) {
    var now = new Date();
    var end = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      endHour,
      59,
      59,
      999
    );
    if (now > end) {
      end.setDate(end.getDate() + 1);
    }
    return end;
  }

  function tickForEl(el) {
    var timeEl = el.querySelector(".s12-cro-countdown-time");
    if (!timeEl) return;

    var endHour = parseInt(el.getAttribute("data-end-hour") || "23", 10);
    if (!el._endDate) {
      el._endDate = computeEndDate(endHour);
    }

    var now = new Date().getTime();
    var diff = el._endDate.getTime() - now;

    if (diff < 0) {
      el._endDate = computeEndDate(endHour);
      diff = el._endDate.getTime() - now;
    }

    var hours = Math.floor(diff / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);
    timeEl.textContent = pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);
  }

  function tickAll() {
    countdownEls.forEach(tickForEl);
  }

  tickAll();
  setInterval(tickAll, 1000);
})();

(function () {
  var toastEl = document.getElementById("s12-cro-toast");
  if (!toastEl) return;

  var names = [
    "Khalid de Casablanca vient de commander.",
    "Sara de Rabat vient de commander.",
    "Youssef de Marrakech vient de commander.",
    "Imane de Fes vient de commander.",
    "Nadia de Agadir vient de commander.",
    "Hamza de Tanger vient de commander."
  ];
  var idx = 0;

  function showToast() {
    toastEl.textContent = names[idx % names.length];
    idx += 1;
    toastEl.classList.add("is-visible");
    setTimeout(function () {
      toastEl.classList.remove("is-visible");
    }, 4000);
  }

  var firstDelay = 4000 + Math.floor(Math.random() * 4000);
  setTimeout(function () {
    showToast();
    setInterval(showToast, 45000);
  }, firstDelay);
})();

(function () {
  var buyBtn = document.getElementById("s12-floating-buy-btn");
  if (!buyBtn) return;

  function findBuyTarget() {
    return (
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector(".shopify-payment-button") ||
      document.querySelector('[id*="shopify-section"][id*="beats_product"]') ||
      document.querySelector(".shopify-section")
    );
  }

  buyBtn.addEventListener("click", function (event) {
    event.preventDefault();
    var target = findBuyTarget();
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
})();
